module.exports = __webpack_public_path__ + "static/media/useful2.e3457344.png";